// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.attribute_change_source */
var AttributeChangeSource;
(function (AttributeChangeSource) {
    AttributeChangeSource["MANUAL_EDIT"] = "MANUAL_EDIT";
    AttributeChangeSource["TEMPLATE_MIGRATION"] = "TEMPLATE_MIGRATION";
    AttributeChangeSource["RESTORE"] = "RESTORE";
    AttributeChangeSource["IMPORT"] = "IMPORT";
})(AttributeChangeSource || (AttributeChangeSource = {}));
;
export default AttributeChangeSource;
/** Zod schema for attribute_change_source */
export const attributeChangeSource = z.nativeEnum(AttributeChangeSource);
//# sourceMappingURL=AttributeChangeSource.js.map